import { render, staticRenderFns } from "./good.vue?vue&type=template&id=107e70fb&scoped=true&"
import script from "./good.vue?vue&type=script&lang=js&"
export * from "./good.vue?vue&type=script&lang=js&"
import style0 from "./good.vue?vue&type=style&index=0&id=107e70fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107e70fb",
  null
  
)

export default component.exports